import { FC } from 'react'
import { DashboardDivider } from '../../components/Divider'
import { isLocalnet } from '../../utils/route-utils'
import { Social } from '../../components/Social'
import { LatestRuntimeBlocks } from './LatestRuntimeBlocks'
import { LatestRuntimeTransactions } from './LatestRuntimeTransactions'
import { TransactionsStats } from '../../components/TransactionsStats'
import { TotalTransactions } from '../../components/TotalTransactions'
import { PageLayout } from '../../components/PageLayout'
import { ParaTimeSnapshot } from './ParaTimeSnapshot'
import { TopTokens } from './TopTokens'
import { useRuntimeScope } from '../../hooks/useScopeParam'
import { useRuntimeTxMethodParam } from '../../hooks/useCommonParams'

export const ParatimeDashboardPage: FC = () => {
  const scope = useRuntimeScope()
  const isLocal = isLocalnet(scope.network)
  const { txMethod, setTxMethod } = useRuntimeTxMethodParam()

  return (
    <PageLayout>
      {!isLocal && <ParaTimeSnapshot scope={scope} />}
      <DashboardDivider />
      <LatestRuntimeTransactions scope={scope} txMethod={txMethod} setTxMethod={setTxMethod} />
      <LatestRuntimeBlocks scope={scope} />
      <TopTokens scope={scope} />
      {!isLocal && (
        <>
          <div className="grid grid-cols-12 gap-x-6">
            <div className="col-span-12 lg:col-span-6">
              <TransactionsStats scope={scope} />
            </div>
            <div className="col-span-12 lg:col-span-6">
              <TotalTransactions scope={scope} />
            </div>
          </div>
          <Social />
        </>
      )}
    </PageLayout>
  )
}
